import React, { Fragment, useContext, useEffect, useState, createContext } from "react";
import BackOfficeNavbar from "./../../components/navbars/BackOfficeNavbar";
import Schedule from "../schedule/Schedule";
import LoginPage from "./LoginPage";
import UsersList from "./users/UsersList";
import UserDetails from "./users/userDetails/UserDetails";
import { BasicContext } from "../../App";
import NoPermission from "../../components/NoPermission";
import AddUser from "./users/AddUser";
import ClassesLevels from "./templates/ClassesLevels";
import ClassesCategories from "./templates/ClassesCategories";
import ClassesTemplates from "./templates/ClassesTemplates";
import AddEditClassTemplate from "./templates/AddEditClassTemplate";
import CreatingClass from "./classes/CreatingClass";
import PassesList from "./passes/PassesList";
import AddEditPass from "./passes/AddEditPass";
import Settings from "./Settings";
import UserLogs from "./UserLogs";
import DiscountCodesList from "./codes/DiscountCodesList";
import CreateDiscountCode from "./codes/CreateDiscountCode";
import StudentsPasses from "./passes/StudentsPasses";
import { postMethod } from "../../requests";
import ReservationsList from "../reservations/ReservationsList";
import TransactionsList from "./transactions/TransactionsList";
import UserProfile from "../UserProfile";
import CreateReservation from "../reservations/CreateReservation";
import HistoryClasses from "./classes/HistoryClasses";
import CheckAttendance from "./classes/CheckAttendance";
import Reports from "./reports/Reports";
import AddPassToUser from "./passes/AddPassToUser";
import AddUserToClass from "./classes/AddUserToClass";
import FrontPageCMS from "./FrontPageCMS";
import EditUserPass from "./passes/EditUserPass";
import ChangePassAttachment from "./classes/ChangePassAttachment";
export const BackOfficeContext = createContext();

const BackOffice = () => {
    const { isLogged, fetchMainData, noPermission, showView, setShowView, checkServerData, setAlerts, setLoading } = useContext(BasicContext);
    const [passesList, setPassesList] = useState(null);
    const [classesTemplates, setClassesTemplates] = useState(null);
    const [reservationsList, setReservationsList] = useState(null);
    const [discoutCodesList, setDiscoutCodesList] = useState(null);
    const [settings, setSettings] = useState(null);

    const getGlobalSettings = async () => {
        const res = await postMethod("/get-global-settings");
        if (checkServerData(res)) setSettings(res.data.settings);
    };

    const loadAdminPanel = async () => {
        const res = await postMethod("/load-admin-panel");

        if ((!checkServerData(res) && res.status === 403) || (checkServerData(res) && !res.data.status)) {
            setAlerts([]);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (showView) {
            const main = document.getElementById("main"),
                footerMain = document.getElementById("footerMain").offsetHeight;
            main.style.minHeight = `${window.innerHeight - footerMain - 61}px`;
        }
        // eslint-disable-next-line
    }, [showView]);

    useEffect(() => {
        if (isLogged) {
            setShowView({ nav: "schedule", sub: "main", params: { moduleName: "ADMIN_APP" } });
            getGlobalSettings();
            loadAdminPanel();
        }
        // eslint-disable-next-line
    }, [isLogged]);

    useEffect(() => {
        fetchMainData();

        // eslint-disable-next-line
    }, []);

    return (
        <BackOfficeContext.Provider
            value={{
                classesTemplates,
                setClassesTemplates,
                passesList,
                setPassesList,
                discoutCodesList,
                setDiscoutCodesList,
                settings,
                reservationsList,
                setReservationsList,
            }}
        >
            {noPermission ? (
                <NoPermission />
            ) : isLogged === false ? (
                <LoginPage />
            ) : isLogged ? (
                <Fragment>
                    {showView && (
                        <Fragment>
                            <BackOfficeNavbar />
                            <main id="main">
                                {showView.nav === "schedule" && (
                                    <>
                                        {showView.sub === "main" && <Schedule />}
                                        {showView.sub === "checkAttendance" && <CheckAttendance />}
                                    </>
                                )}
                                {showView.nav === "reservations" && (
                                    <>
                                        {showView.sub === "reservationsList" && <ReservationsList />}
                                        {showView.sub === "createReservation" && <CreateReservation />}
                                    </>
                                )}
                                {showView.nav === "classes" && (
                                    <>
                                        {showView.sub === "creatingClass" && <CreatingClass />}
                                        {showView.sub === "historyClasses" && <HistoryClasses />}
                                        {showView.sub === "addUserToClass" && <AddUserToClass />}
                                    </>
                                )}
                                {showView.nav === "templates" && (
                                    <>
                                        {showView.sub === "classesTemplates" && <ClassesTemplates />}
                                        {(showView.sub === "addTemplate" || showView.sub === "editTemplate") && <AddEditClassTemplate />}
                                        {showView.sub === "classesLevels" && <ClassesLevels />}
                                        {showView.sub === "classesCategories" && <ClassesCategories />}
                                        {showView.sub === "frontPage" && <FrontPageCMS />}
                                    </>
                                )}
                                {showView.nav === "users" && (
                                    <>
                                        {showView.sub === "usersList" && <UsersList />}
                                        {showView.sub === "addUser" && <AddUser />}
                                        {showView.sub === "userDetails" && <UserDetails />}
                                    </>
                                )}
                                {showView.nav === "transactions" && <>{showView.sub === "transactionsList" && <TransactionsList />}</>}
                                {showView.nav === "passes" && (
                                    <>
                                        {showView.sub === "passesList" && <PassesList />}
                                        {showView.sub === "createPass" && <AddEditPass />}
                                        {showView.sub === "editPass" && <AddEditPass />}
                                        {showView.sub === "studentsPasses" && <StudentsPasses />}
                                        {showView.sub === "addPassToUser" && <AddPassToUser />}
                                        {showView.sub === "editUserPass" && <EditUserPass />}
                                        {showView.sub === "changePassAttachment" && <ChangePassAttachment />}
                                    </>
                                )}
                                {showView.nav === "settings" && <Settings />}
                                {showView.nav === "userLogs" && <UserLogs />}
                                {showView.nav === "codes" && (
                                    <>
                                        {showView.sub === "discountCodesList" && <DiscountCodesList />}
                                        {showView.sub === "createCode" && <CreateDiscountCode />}
                                    </>
                                )}
                                {showView.nav === "userProfile" && <UserProfile />}
                                {showView.nav === "reports" && <Reports />}
                            </main>
                        </Fragment>
                    )}
                </Fragment>
            ) : null}
        </BackOfficeContext.Provider>
    );
};

export default BackOffice;
